import { render, staticRenderFns } from "./cardLessons.vue?vue&type=template&id=5ebf6c0a&scoped=true&lang=pug&"
import script from "./cardLessons.vue?vue&type=script&lang=js&"
export * from "./cardLessons.vue?vue&type=script&lang=js&"
import style0 from "./cardLessons.vue?vue&type=style&index=0&id=5ebf6c0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf6c0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
